import { environment } from 'environments/environment';

const CDN_BASE_URL = environment.cdnAssetsBasePath;

const baseUrl = CDN_BASE_URL + 'uds_icons/';

export const SvgMap = {
  HeaderUser: `${baseUrl}share_person.ods.svg`,
  helpCenter: `${baseUrl}helpCenter.ods.svg`,
  notification: `${baseUrl}notification.ods.svg`,
  notificationFilled: `${baseUrl}notificationFilled.ods.svg`,
  invoices: `${baseUrl}invoices.ods.svg`,
  advanceConsent: `${baseUrl}advance-consent.ods.svg`,
  logout: `${baseUrl}logout.ods.svg`,
  manage_users: `${baseUrl}user_settings.ods.svg`,
  user_settings: `${baseUrl}user_settings.ods.svg`,
  company_settings: `${baseUrl}user_settings.ods.svg`,
  partnersManagement: `${baseUrl}partners_management.ods.svg`,
  support: `${baseUrl}online_chat.ods.svg`,
  contact: `${baseUrl}contact.ods.svg`,
  tutorial: `${baseUrl}tutorial.svg`,
  info: `${baseUrl}helpCenter.ods.svg`,
  infoIcon: `${baseUrl}info-exclamation.ods.svg`,
  // header.component
  addTag: `${baseUrl}add-1.ods.svg`,
  flag: `${baseUrl}flag-b.ods.svg`,
  flagFilled: `${baseUrl}flagFilled.ods.svg`,
  share_person: `${baseUrl}share_person.ods.svg`,
  document: `${baseUrl}document.ods.svg`,
  note: `${baseUrl}note.ods.svg`,
  product: `${baseUrl}orders.ods.svg`,
  productMaster: `${baseUrl}product_master.ods.svg`,
  report: `${baseUrl}report.ods.svg`,
  exception: `${baseUrl}report.ods.svg`,
  exceptionWarning: `${baseUrl}report.ods.svg`,
  exceptionIcon: `${baseUrl}report.ods.svg`,
  exceptionIcon2: `${baseUrl}report.ods.svg`,
  pod: `${baseUrl}pod.svg`,
  edit: `${baseUrl}edit.ods.svg`,
  search: `${baseUrl}search.ods.svg`,
  search_blue: `${baseUrl}search.ods.svg`,
  export: `${baseUrl}download.ods.svg`,
  notFoundContainers: `${baseUrl}notFoundContainers.svg`,
  noResultMileStones: `${baseUrl}noResultMileStones.png`,
  noResultSchedules: `${baseUrl}noResultSchedules.png`,
  noResultExceptions: `${baseUrl}noResultExceptions.png`,
  noNotifications: `${baseUrl}noNotifications.png`,
  noResultTbgLeft: `${baseUrl}noResultTbgLeft.png`,
  noOrderProductsFound: `${baseUrl}noOrderProductsFound.png`,
  noOrderShipmentsFound: `${baseUrl}noOrderShipmentsFound.png`,
  noCalendarFound: `${baseUrl}noCalendarFound.png`,
  noCalendarFoundHR: `${baseUrl}noCalendarFoundHighResolution.png`,
  noExceptionsFound: `${baseUrl}noCalendarFound.png`,
  noMilestonesFound: `${baseUrl}noMilestonesFound.png`,
  oceanOnDashboard: `${baseUrl}oceanOnDashboard.png`,
  airOnDashboard: `${baseUrl}airOnDashboard.png`,
  noResultTbg: `${baseUrl}noResultTbg.png`,
  noExceptions: `${baseUrl}noExceptions.ods.svg`,
  noResultFound: `${baseUrl}search.ods.svg`,
  addContainer: `${baseUrl}addContainer.ods.svg`,
  history: `${baseUrl}predicted_eta.ods.svg`,
  upload: `${baseUrl}upload.ods.svg`,
  open_eye: `${baseUrl}open_eye.ods.svg`,
  open_eye_gray: `${baseUrl}closed_eye.ods.svg`,
  filter: `${baseUrl}filter.ods.svg`,
  filter1: `${baseUrl}filter.ods.svg`,
  filterActive: `${baseUrl}filter.ods.svg`,
  delete: `${baseUrl}delete.ods.svg`,
  complete: `${baseUrl}complete.ods.svg`,
  inComplete: `${baseUrl}inComplete.ods.svg`,
  shareLink: `${baseUrl}link.ods.svg`,
  arrowDown: `${baseUrl}arrowDown.ods.svg`,
  arrowUp: `${baseUrl}arrowUp.ods.svg`,
  airFreight: `${baseUrl}air-shipments.ods.svg`,
  uds_delete: `${baseUrl}delete.ods.svg`,
  f_tracking: `${baseUrl}milestone.ods.svg`,
  f_supplyChain: `${baseUrl}f_supplyChain.ods.svg`,
  f_exception: `${baseUrl}report.ods.svg`,
  f_insight: `${baseUrl}demdetGraph.ods.svg`,
  demurrage_configuration: `${baseUrl}demurrage-configuration.ods.svg`,
  airShipment: `${baseUrl}air-shipments.ods.svg`,
  olShipment: `${baseUrl}product_master.ods.svg`,
  roadShipment: `${baseUrl}road-1.ods.svg`,
  flight: `${baseUrl}air-shipments.ods.svg`,
  vessel: `${baseUrl}vessel.ods.svg`,
  co2: `${baseUrl}co2.ods.svg`,
  blueTick: `${baseUrl}complete.ods.svg`,
  whiteTick: `${baseUrl}whiteTickIcon.ods.svg`,
  closeIcon: `${baseUrl}close-icon.ods.svg`,
  closeIcon2: `${baseUrl}close-icon.ods.svg`,
  dragIcon: `${baseUrl}drag.ods.svg`,
  shipments: `${CDN_BASE_URL}svg/on_water.ods.svg`,
  air_shipments: `${baseUrl}air-shipments.ods.svg`,
  truck: `${baseUrl}road-1.ods.svg`,
  expand: `${baseUrl}expand.ods.svg`,
  expandRev: `${baseUrl}expand-rev.ods.svg`,
  predictedEta: `${baseUrl}predicted_eta.ods.svg`,
  arrivingPredictedEta: `${baseUrl}predicted_eta.ods.svg`,
  infoExclamation: `${baseUrl}info-exclamation.ods.svg`,
  carouselLeft: `${baseUrl}carousel-left.svg`,
  carouselRight: `${baseUrl}carousel-right.svg`,
  closeIconFilter: `${baseUrl}close-icon.ods.svg`,
  demdetGraph: `${baseUrl}demdetGraph.svg`,
  demdetTable: `${baseUrl}demdetTable.svg`,
  config_icon: `${baseUrl}config_icon.ods.svg`,
  graph_loader: `${baseUrl}graph_loader.ods.svg`,
  no_graph_data: `${baseUrl}no_graph_data.svg`,
  customisation_icon: `${baseUrl}customisation_icon.svg`,
  port_vessel_change: `${baseUrl}port_vessel_change.svg`,
  checkConsentStatus: `${baseUrl}advance-consent.ods.svg`,
  vehicleupdate: `${baseUrl}road-1.ods.svg`,
  vehiclenotupdate: `${baseUrl}vehiclenotupdate.ods.svg`,
  warningvehicle: `${baseUrl}report.ods.svg`,
  milestone: `${baseUrl}milestone.ods.svg`,
  time: `${baseUrl}time.ods.svg`,
  user_1: `${baseUrl}user-1.ods.svg`,
  user_3: `${baseUrl}user-3.ods.svg`,
  noNewsResult: `${baseUrl}no_news_result.svg`,
  interModalJourney: `${baseUrl}intermodal-journey.svg`,
  locations2: `${baseUrl}locations.ods.svg`,
  storage_cost_icon: `${baseUrl}storage_cost.ods.svg`,
  chatbotIcon: `${baseUrl}note.ods.svg`,
  retrigger: `${baseUrl}retrigger.ods.svg`,
  gps_lost_marker: `${baseUrl}gps_lost_marker.svg`,
  heatMapIcon: `${baseUrl}heatMapIcon.ods.svg`,

  inPortGrey: `${CDN_BASE_URL}svg/in_port.ods.svg`,
  facilityGrey: `${CDN_BASE_URL}svg/facility.ods.svg`,
  onWaterGrey: `${CDN_BASE_URL}svg/on_water.ods.svg`,
  truckGrey: `${CDN_BASE_URL}uds_icons/road-1.ods.svg`,
  airGrey: `${CDN_BASE_URL}uds_icons/air-shipments.ods.svg`,
  flowNewSquare: `${CDN_BASE_URL}cargoflow-new-square.svg`,
  tracking: `${CDN_BASE_URL}images/tracking.png`,
  exception2: `${CDN_BASE_URL}images/exception.png`,
  visibility: `${CDN_BASE_URL}images/visibility.png`,
  insight: `${CDN_BASE_URL}images/insight.png`,
};
